import { render, staticRenderFns } from "./ProjectSite.vue?vue&type=template&id=27c9f30e&scoped=true"
import script from "./ProjectSite.vue?vue&type=script&lang=js"
export * from "./ProjectSite.vue?vue&type=script&lang=js"
import style0 from "./ProjectSite.vue?vue&type=style&index=0&id=27c9f30e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c9f30e",
  null
  
)

export default component.exports